import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=8446cd7a&scoped=true&lang=html&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8446cd7a",
  null
  
)

export default component.exports